import { render } from "./StructureForm.vue?vue&type=template&id=93ab5c08&scoped=true"
import script from "./StructureForm.vue?vue&type=script&lang=js"
export * from "./StructureForm.vue?vue&type=script&lang=js"

import "./StructureForm.vue?vue&type=style&index=0&id=93ab5c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ab5c08"]])

export default __exports__